import React from 'react'
// import PropTypes from 'prop-types'

import IconButton from '@material-ui/core/IconButton'

import SettingsIcon from '@material-ui/icons/Settings'
import DeleteIcon from '@material-ui/icons/Delete'
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd'

export default function Options({ addAction, editAction, deleteAction, obj }) {
    return (
        <>
            <IconButton
                edge="end"
                aria-label="settings"
                onClick={event => editAction(obj)}
            >
                <SettingsIcon />
            </IconButton>
            {addAction !== null && (
                <IconButton
                    edge="end"
                    aria-label="add new item"
                    onClick={event => addAction(obj)}
                >
                    <PlaylistAddIcon />
                </IconButton>
            )}
            {deleteAction !== null && (
                <IconButton
                    edge="end"
                    aria-label="delete"
                    onClick={event => deleteAction(obj)}
                >
                    <DeleteIcon />
                </IconButton>
            )}
        </>
    )
}
